// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"cp_a bhe_a bhe_w","Messages__hasSeen":"cp_b bhe_p"};